export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref15116.8b840173.jpg";